import React from 'react';

const NotAuthorized = ({}) => {
  return <div id='not-authorized'>Sorry Buddy, You cant go whereever you wish without sufficient permissions!</div>;
};

export default NotAuthorized;
